import { thirdPartyAuthStore, xoyoAuthStore } from '@src/mobx-store/root-store/auth';
import Toast from '@src/components/toast';
import reload from '@src/utils/reload';
import { computed, observable } from 'mobx';
import AccountInfoStore from '@src/components/account-info/store';
import { props } from '@src/utils/link-store';
import { px2rem } from '@src/utils/rem-util';
import Services from '../../services/general';

export default class BusinessAccountInfoStore extends AccountInfoStore {
  //是否开启剑网3免登
  @observable isIngame ;

  @computed
  get isLogin() {
    // 判断是否存在用户账号名来确认是否存在
    return !!window.XPASS.u_account;
  }

  /**
   * 用户登录
   * @returns {*}
   */
  @observable
  signIn = () => {
    return window.XPASS.signin();
  };

  /**
   * 退出
   */
  /**
   * 退出
   */
  @observable
  logout = async () => {
    this.isIngame && await Services.logoutIngame();
    window.XPASS.exit();
  };

  @computed
  get username() {
    return window.XPASS.u_account;
  }


  @computed
  get xoyoAuthUsername() {
    let xoyoUsername = xoyoAuthStore.username;
    if (thirdPartyAuthStore && thirdPartyAuthStore.loginType === 'passport') {
      xoyoUsername = thirdPartyAuthStore.username;
    }
    return xoyoUsername;
  }

  /**
   * 当 xoyo 登录存在时, 同时没有第三方登录
   * @type {boolean}
   */
  @observable isAllowLogout = !!xoyoAuthStore.username && !thirdPartyAuthStore.username;

  @observable
  onLoginSuccess() {
    reload();
  }

  @observable
  onLogoutSuccess() {
    Toast.success('登出成功');
    reload();
  }

  @props
  style = {
    position: 'absolute',
    top: px2rem('40px'),
    right: px2rem('40px')
  };
}
